export default __webpack_public_path__ + "static/media/csv.f3f14738.svg";